import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { ThemeProvider, createTheme } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'
import { Toaster, ToastBar, toast } from 'react-hot-toast'
import App from './App.tsx'

// Tema personalizată pentru aplicația medicală
const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2', // Albastru medical
    },
    secondary: {
      main: '#dc004e', // Roșu pentru alerte
    },
    background: {
      default: '#f5f5f5',
      paper: '#ffffff',
    },
  },
  typography: {
    fontFamily: 'Roboto, Arial, sans-serif',
    h4: {
      fontWeight: 600,
    },
    h5: {
      fontWeight: 500,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 8,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        },
      },
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <App />
        <Toaster
          position="bottom-right"
          reverseOrder={true}
          toastOptions={{
            duration: 4000,
            style: {
              background: '#363636',
              color: '#fff',
            },
          }}
        >
          {(t) => (
            <ToastBar toast={t}>
              {({ icon, message }) => (
                <>
                  {icon}
                  {message}
                  <button 
                    onClick={() => toast.dismiss(t.id)}
                    style={{
                      background: 'transparent',
                      border: 'none',
                      color: '#fff',
                      cursor: 'pointer',
                      fontSize: '16px',
                      fontWeight: 'bold',
                      padding: '4px 8px',
                      marginLeft: '8px',
                      borderRadius: '4px',
                    }}
                    onMouseOver={(e) => (e.target as HTMLButtonElement).style.background = 'rgba(255,255,255,0.2)'}
                    onMouseOut={(e) => (e.target as HTMLButtonElement).style.background = 'transparent'}
                  >
                    ×
                  </button>
                </>
              )}
            </ToastBar>
          )}
        </Toaster>
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>,
)
